import { Component, OnInit, Type } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { SharedService } from '../../services/shared.service'

@Component({
	selector: 'app-recaptcha',
	templateUrl: './recaptcha.component.html',
	styleUrls: ['./recaptcha.component.css']
})
export class RecaptchaComponent implements OnInit {
	aFormGroup: FormGroup
	siteKey: string

	constructor(
		private sharedService: SharedService,
		private formBuilder: FormBuilder,
		) { 
			this.siteKey = sharedService.recaptchaSiteKey
		}

	ngOnInit() {
		this.aFormGroup = this.formBuilder.group({
			recaptcha: ['', Validators.required]
		});
	}

	onReset(): void {
		console.log('onReset()')
	}

	onExpire(): void {
		console.log('onExpire()')
	}

	onLoad(): void {
		console.log('onLoad()')
	}

	onSuccess(e: any): void {
		console.log('onSuccess(' + e + ')')
	}
}
